import { scrumIntro, learningObjectivesIntro, activitiesListIntro, standardActivities, initialPost, standardActivitiesClosing, estimated, closing } from './AL00000Sprint00'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { internalLink } from '../DataAndAPIs/Links'

import { oreillyPlaylistSA } from '../DataAndAPIs/Links'
import { toolsOfTheTradeLink } from '../Activities/ToolsOfTheTrade'
import { htmlLink } from '../Activities/HTML'
import { HelloWorldWebLink } from '../Activities/HelloWorld' 
import { prefaceLecture, chapter01Lecture, chapter02Lecture } from '../ActivityVideo/ActivityArchitecture'
import { gettingToKnowEachOtherLink } from '../Activities/WebGettingToKnowEachOther'

export const al61200Sprint01 = (classSectionID, sprint) => { 
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>
		<p>Does the potential of building beautiful and inspirational software intrigue you? Have you ever wondered how 
		to elevate your software development skills beyond basic classes and functions? If these questions excite you,
		you are in the right place.</p>

		<p>For most software programmers, software architecture, perhaps, means performing software design at a higher 
		level of abstraction and on a larger scale, although this is true to some degree, it certainly does not capture 
		the full breadth of responsibilities and activities carried out in the software architecture realm. Software 
		architecture is the glue that ensures various elements of a complex software system work in tandem and that 
		final software product achieves its internal and external quality as well as meeting its functional and 
		non-functional requirements. Furthermore, a good software architecture must withstand the test of time, it 
		must lend itself to a changing business as well as technical environment, and it certainly should allow for 
		seamless addition of functionality. While the quality of as a software programmer code can be conveniently and 
		immediately verified with a unit test, the quality of a software architect’s design can only be judged long 
		after the initial release of the product and only after many changes in the business environment and technical 
		landscape have occurred. Week 1 serves as an introduction to software architecture, you will be introduced to 
		key architectural styles, architecture and development life-cycle, various stakeholders concerned with 
		architecture and much more.</p>

		<p>As you embark on this journey of learning software architecture, I encourage you to be curious, ask questions,
		and seek answers. The more you put into this class, the more you will get out of it.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Explain what software architecture is to various stakeholders</li>
			<li>Summarize responsibilities of the software architecture role in the development team</li>
			<li>List and explain different architectural views</li>
			<li>Discuss Software Architecture in the context of product life-cycle as well as business and professional context</li>
			<li>Articulate what makes a good architecture considering various internal and external quality factors</li>
			<li>Explain and highlight differences between software architecture and software design and enterprise architecture</li>
		</ul>
		{scrumIntro(classSectionID, sprint)}
		{list61200Sprint01(sprint)}
		{closing(sprint)}	
	</div> )
}

export const list61200Sprint01 = (sprint) => {
	const conceptsAndPractices = () => { return internalLink('Object-Oriented Programming Concepts and Practices', '/activity-oop/concepts-and-practices') }

	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, gettingToKnowEachOtherLink())}
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Preface” and watch the associated {prefaceLecture()}</li>
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapter 1” and watch the associated {chapter01Lecture()}</li>

			<li>Complete {htmlLink()} and {HelloWorldWebLink()}</li>
			{initialPost(sprint)}
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapter 2” and watch the associated {chapter02Lecture()}</li>
			<li>Review {conceptsAndPractices()} as needed</li>

			<li>Complete {toolsOfTheTradeLink()}{estimated('2 hours')}</li>
			{standardActivitiesClosing(sprint, gettingToKnowEachOtherLink(), '4 hours')}
		</ol>
	</div> )
}
